enum SignUpEndpoints {
  SignUp = '/registration-ms/v1/ms/signup',
  SignUpPDV = '/account-ms/v1/ms/pdv/richiestaAttivazione',
  ValidateUsername = '/registration-ms/v1/ms/validator/validateUsername',
  ConfirmEmail = '/registration-ms/v1/ms/validator/confirmEmail',
  WelcomeBonus = '/bonus-ms/v1/promotions',
}

export default SignUpEndpoints;
